"use client";

import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import { smallButtonClasses } from '@wt/shared/components/buttons/SmallButton';
import { useControls } from 'react-zoom-pan-pinch';

export function ZoomInOutButtons() {
  const { zoomIn, zoomOut } = useControls();

  return (
    <>
      <div
        className={`pointer-events-auto ${smallButtonClasses} rounded-r-none`}
      >
        <RemoveRoundedIcon htmlColor={'black'} onClick={() => zoomOut()} />
      </div>
      <div
        className={`pointer-events-auto ${smallButtonClasses} rounded-l-none`}
      >
        <AddRoundedIcon htmlColor={'black'} onClick={() => zoomIn()} />
      </div>
    </>
  );
}